import {isNil} from 'lodash'
import {t} from "helpers/language"

export const LocationTypes = {
  general: 0,
  main: -1,
  registered: -2,
  accounts: -3,
  delivery: -4,
}


export const getTypes = () => {
  return [{
    key: 0,
    value: 0,
    label: t('General'),
  }, {
    key: -1,
    value: -1,
    label: t('Main'),
  }, {
    key: -2,
    value: -2,
    label: t('Registered'),
  }, {
    key: -3,
    value: -3,
    label: t('Accounts'),
  }, {
    key: -4,
    value: -4,
    label: t('Delivery'),
  },
  ]
}

export const getCountries = () => {
  return [
    {label: 'Afghanistan', value: 'Afghanistan'},
    {label: 'Aland Islands', value: 'Aland Islands'},
    {label: 'Albania', value: 'Albania'},
    {label: 'Algeria', value: 'Algeria'},
    {label: 'American Samoa', value: 'American Samoa'},
    {label: 'Andorra', value: 'Andorra'},
    {label: 'Angola', value: 'Angola'},
    {label: 'Anguilla', value: 'Anguilla'},
    {label: 'Antigua', value: 'Antigua'},
    {label: 'Argentina', value: 'Argentina'},
    {label: 'Armenia', value: 'Armenia'},
    {label: 'Aruba', value: 'Aruba'},
    {label: 'Australia', value: 'Australia'},
    {label: 'Austria', value: 'Austria'},
    {label: 'Azerbaijan', value: 'Azerbaijan'},
    {label: 'Bahamas', value: 'Bahamas'},
    {label: 'Bahrain', value: 'Bahrain'},
    {label: 'Bangladesh', value: 'Bangladesh'},
    {label: 'Barbados', value: 'Barbados'},
    {label: 'Belarus', value: 'Belarus'},
    {label: 'Belgium', value: 'Belgium'},
    {label: 'Belize', value: 'Belize'},
    {label: 'Benin', value: 'Benin'},
    {label: 'Bermuda', value: 'Bermuda'},
    {label: 'Bhutan', value: 'Bhutan'},
    {label: 'Bolivia', value: 'Bolivia'},
    {label: 'Bosnia-Herzegovina', value: 'Bosnia-Herzegovina'},
    {label: 'Botswana', value: 'Botswana'},
    {label: 'Bouvet Island', value: 'Bouvet Island'},
    {label: 'Brazil', value: 'Brazil'},
    {label: 'Brunei Darussalam', value: 'Brunei Darussalam'},
    {label: 'Bulgaria', value: 'Bulgaria'},
    {label: 'Burkina Faso', value: 'Burkina Faso'},
    {label: 'Burundi', value: 'Burundi'},
    {label: 'Cambodia', value: 'Cambodia'},
    {label: 'Cameroon', value: 'Cameroon'},
    {label: 'Canada', value: 'Canada'},
    {label: 'Cape Verde', value: 'Cape Verde'},
    {label: 'Cayman Islands', value: 'Cayman Islands'},
    {label: 'Central African Republic', value: 'Central African Republic'},
    {label: 'Chad', value: 'Chad'},
    {label: 'Chile', value: 'Chile'},
    {label: 'China', value: 'China'},
    {label: 'Christmas Island', value: 'Christmas Island'},
    {label: 'Cocos Islands', value: 'Cocos Islands'},
    {label: 'Colombia', value: 'Colombia'},
    {label: 'Comoros', value: 'Comoros'},
    {label: 'Congo', value: 'Congo'},
    {label: 'Cook Islands', value: 'Cook Islands'},
    {label: 'Costa Rica', value: 'Costa Rica'},
    {label: 'Croatia', value: 'Croatia'},
    {label: 'Cuba', value: 'Cuba'},
    {label: 'Curacao', value: 'Curacao'},
    {label: 'Cyprus', value: 'Cyprus'},
    {label: 'Czech Republic', value: 'Czech Republic'},
    {label: 'Denmark', value: 'Denmark'},
    {label: 'Djibouti', value: 'Djibouti'},
    {label: 'Dominica', value: 'Dominica'},
    {label: 'Dominican Republic', value: 'Dominican Republic'},
    {label: 'Ecuador', value: 'Ecuador'},
    {label: 'Egypt', value: 'Egypt'},
    {label: 'El Salvador', value: 'El Salvador'},
    {label: 'England', value: 'England'},
    {label: 'Equatorial Guinea', value: 'Equatorial Guinea'},
    {label: 'Eritrea', value: 'Eritrea'},
    {label: 'Estonia', value: 'Estonia'},
    {label: 'Ethiopia', value: 'Ethiopia'},
    {label: 'Falkland Islands', value: 'Falkland Islands'},
    {label: 'Faroe Islands', value: 'Faroe Islands'},
    {label: 'Fiji', value: 'Fiji'},
    {label: 'Finland', value: 'Finland'},
    {label: 'France', value: 'France'},
    {label: 'French Guiana', value: 'French Guiana'},
    {label: 'French Polynesia', value: 'French Polynesia'},
    {label: 'Gabon', value: 'Gabon'},
    {label: 'Gambia', value: 'Gambia'},
    {label: 'Georgia', value: 'Georgia'},
    {label: 'Germany', value: 'Germany'},
    {label: 'Ghana', value: 'Ghana'},
    {label: 'Gibraltar', value: 'Gibraltar'},
    {label: 'Greece', value: 'Greece'},
    {label: 'Greenland', value: 'Greenland'},
    {label: 'Grenada', value: 'Grenada'},
    {label: 'Guadeloupe', value: 'Guadeloupe'},
    {label: 'Guam', value: 'Guam'},
    {label: 'Guatemala', value: 'Guatemala'},
    {label: 'Guernsey', value: 'Guernsey'},
    {label: 'Guinea', value: 'Guinea'},
    {label: 'Guyana', value: 'Guyana'},
    {label: 'Haiti', value: 'Haiti'},
    {label: 'Hawaii', value: 'Hawaii'},
    {label: 'Honduras', value: 'Honduras'},
    {label: 'Hong Kong', value: 'Hong Kong'},
    {label: 'Hungary', value: 'Hungary'},
    {label: 'Ibiza', value: 'Ibiza'},
    {label: 'Iceland', value: 'Iceland'},
    {label: 'India', value: 'India'},
    {label: 'Indonesia', value: 'Indonesia'},
    {label: 'Iran', value: 'Iran'},
    {label: 'Iraq', value: 'Iraq'},
    {label: 'Ireland', value: 'Ireland'},
    {label: 'Isle Of Man', value: 'Isle Of Man'},
    {label: 'Israel', value: 'Israel'},
    {label: 'Italy', value: 'Italy'},
    {label: 'Ivory Coast', value: 'Ivory Coast'},
    {label: 'Jamaica', value: 'Jamaica'},
    {label: 'Japan', value: 'Japan'},
    {label: 'Jersey', value: 'Jersey'},
    {label: 'Jordan', value: 'Jordan'},
    {label: 'Kazakhstan', value: 'Kazakhstan'},
    {label: 'Kenya', value: 'Kenya'},
    {label: 'Kiribati', value: 'Kiribati'},
    {label: 'Kuwait', value: 'Kuwait'},
    {label: 'Kyrgyzstan', value: 'Kyrgyzstan'},
    {label: 'Lao', value: 'Lao'},
    {label: 'Latvia', value: 'Latvia'},
    {label: 'Lebanon', value: 'Lebanon'},
    {label: 'Lesotho', value: 'Lesotho'},
    {label: 'Liberia', value: 'Liberia'},
    {label: 'Libya', value: 'Libya'},
    {label: 'Liechtenstein', value: 'Liechtenstein'},
    {label: 'Lithuania', value: 'Lithuania'},
    {label: 'Luxembourg', value: 'Luxembourg'},
    {label: 'Macao', value: 'Macao'},
    {label: 'Macedonia', value: 'Macedonia'},
    {label: 'Madagascar', value: 'Madagascar'},
    {label: 'Malawi', value: 'Malawi'},
    {label: 'Malaysia', value: 'Malaysia'},
    {label: 'Maldives', value: 'Maldives'},
    {label: 'Mali', value: 'Mali'},
    {label: 'Malta', value: 'Malta'},
    {label: 'Marshall Islands', value: 'Marshall Islands'},
    {label: 'Martinique', value: 'Martinique'},
    {label: 'Mauritania', value: 'Mauritania'},
    {label: 'Mauritius', value: 'Mauritius'},
    {label: 'Mayotte', value: 'Mayotte'},
    {label: 'Mexico', value: 'Mexico'},
    {label: 'Micronesia', value: 'Micronesia'},
    {label: 'Moldova', value: 'Moldova'},
    {label: 'Monaco', value: 'Monaco'},
    {label: 'Mongolia', value: 'Mongolia'},
    {label: 'Montenegro', value: 'Montenegro'},
    {label: 'Montserrat', value: 'Montserrat'},
    {label: 'Morocco', value: 'Morocco'},
    {label: 'Mozambique', value: 'Mozambique'},
    {label: 'Myanmar', value: 'Myanmar'},
    {label: 'Namibia', value: 'Namibia'},
    {label: 'Nauru', value: 'Nauru'},
    {label: 'Nepal', value: 'Nepal'},
    {label: 'Netherlands', value: 'Netherlands'},
    {label: 'New Caledonia', value: 'New Caledonia'},
    {label: 'New Zealand', value: 'New Zealand'},
    {label: 'Nicaragua', value: 'Nicaragua'},
    {label: 'Niger', value: 'Niger'},
    {label: 'Nigeria', value: 'Nigeria'},
    {label: 'Niue', value: 'Niue'},
    {label: 'Norfolk Island', value: 'Norfolk Island'},
    {label: 'North Korea', value: 'North Korea'},
    {label: 'Northern Mariana Islands', value: 'Northern Mariana Islands'},
    {label: 'Norway', value: 'Norway'},
    {label: 'Oman', value: 'Oman'},
    {label: 'Pakistan', value: 'Pakistan'},
    {label: 'Palau', value: 'Palau'},
    {label: 'Panama', value: 'Panama'},
    {label: 'Papua New Guinea', value: 'Papua New Guinea'},
    {label: 'Paraguay', value: 'Paraguay'},
    {label: 'Peru', value: 'Peru'},
    {label: 'Philippines', value: 'Philippines'},
    {label: 'Pitcairn', value: 'Pitcairn'},
    {label: 'Poland', value: 'Poland'},
    {label: 'Portugal', value: 'Portugal'},
    {label: 'Puerto Rico', value: 'Puerto Rico'},
    {label: 'Qatar', value: 'Qatar'},
    {label: 'Reunion', value: 'Reunion'},
    {label: 'Romania', value: 'Romania'},
    {label: 'Russia', value: 'Russia'},
    {label: 'Rwanda', value: 'Rwanda'},
    {label: 'Saint Barthelemy', value: 'Saint Barthelemy'},
    {label: 'Saint Kitts And Nevis', value: 'Saint Kitts And Nevis'},
    {label: 'Saint Lucia', value: 'Saint Lucia'},
    {label: 'Saint Martin', value: 'Saint Martin'},
    {label: 'Saint Pierre And Miquelon', value: 'Saint Pierre And Miquelon'},
    {label: 'Saint Vincent And The Grenadines', value: 'Saint Vincent And The Grenadines'},
    {label: 'Samoa', value: 'Samoa'},
    {label: 'San Marino', value: 'San Marino'},
    {label: 'Sao Tome And Principe', value: 'Sao Tome And Principe'},
    {label: 'Saudi Arabia', value: 'Saudi Arabia'},
    {label: 'Scotland', value: 'Scotland'},
    {label: 'Senegal', value: 'Senegal'},
    {label: 'Serbia', value: 'Serbia'},
    {label: 'Seychelles', value: 'Seychelles'},
    {label: 'Sierra Leone', value: 'Sierra Leone'},
    {label: 'Singapore', value: 'Singapore'},
    {label: 'Sint Maarten', value: 'Sint Maarten'},
    {label: 'Slovakia', value: 'Slovakia'},
    {label: 'Slovenia', value: 'Slovenia'},
    {label: 'Solomon Islands', value: 'Solomon Islands'},
    {label: 'Somalia', value: 'Somalia'},
    {label: 'South Africa', value: 'South Africa'},
    {label: 'South Georgia And The South Sandwich Islands', value: 'South Georgia And The South Sandwich Islands'},
    {label: 'South Korea', value: 'South Korea'},
    {label: 'South Sudan', value: 'South Sudan'},
    {label: 'Spain', value: 'Spain'},
    {label: 'Sri Lanka', value: 'Sri Lanka'},
    {label: 'Sudan', value: 'Sudan'},
    {label: 'Suriname', value: 'Suriname'},
    {label: 'Svalbard And Jan Mayen', value: 'Svalbard And Jan Mayen'},
    {label: 'Swaziland', value: 'Swaziland'},
    {label: 'Sweden', value: 'Sweden'},
    {label: 'Switzerland', value: 'Switzerland'},
    {label: 'Syria', value: 'Syria'},
    {label: 'Taiwan', value: 'Taiwan'},
    {label: 'Tajikistan', value: 'Tajikistan'},
    {label: 'Tanzania', value: 'Tanzania'},
    {label: 'Thailand', value: 'Thailand'},
    {label: 'Timor-Leste', value: 'Timor-Leste'},
    {label: 'Togo', value: 'Togo'},
    {label: 'Tokelau', value: 'Tokelau'},
    {label: 'Tonga', value: 'Tonga'},
    {label: 'Trinidad And Tobago', value: 'Trinidad And Tobago'},
    {label: 'Tunisia', value: 'Tunisia'},
    {label: 'Turvalue', value: 'Turvalue'},
    {label: 'Turkmenistan', value: 'Turkmenistan'},
    {label: 'Turks &amp; Caicos Islands', value: 'Turks &amp; Caicos Islands'},
    {label: 'Tuvalu', value: 'Tuvalu'},
    {label: 'Uganda', value: 'Uganda'},
    {label: 'Ukraine', value: 'Ukraine'},
    {label: 'United Arab Emirates', value: 'United Arab Emirates'},
    {label: 'United Kingdom', value: 'United Kingdom'},
    {label: 'United States', value: 'United States'},
    {label: 'Uruguay', value: 'Uruguay'},
    {label: 'USA', value: 'USA'},
    {label: 'Uzbekistan', value: 'Uzbekistan'},
    {label: 'Vanuatu', value: 'Vanuatu'},
    {label: 'Vatican City', value: 'Vatican City'},
    {label: 'Venezuela', value: 'Venezuela'},
    {label: 'Vietnam', value: 'Vietnam'},
    {label: 'Virgin Islands', value: 'Virgin Islands'},
    {label: 'Wales', value: 'Wales'},
    {label: 'Wallis And Futuna', value: 'Wallis And Futuna'},
    {label: 'Western Sahara', value: 'Western Sahara'},
    {label: 'Yemen', value: 'Yemen'},
    {label: 'Zambia', value: 'Zambia'},
    {label: 'Zimbabwe', value: 'Zimbabwe'},
  ]
}

export const getLocationAddress = (location) => {
  if (!isNil(location)) {
    const address = []
    if (!isNil(location.address1) && location.address1 !== '') address.push(location.address1)
    if (!isNil(location.address2) && location.address2 !== '') address.push(location.address2)
    if (!isNil(location.address3) && location.address3 !== '') address.push(location.address3)
    if (!isNil(location.city) && location.city !== '') address.push(location.city)
    if (!isNil(location.county) && location.county !== '') address.push(location.county)
    if (!isNil(location.postCode) && location.postCode !== '') address.push(location.postCode)
    if (!isNil(location.country) && location.country !== '') address.push(location.country)
    return address.join(', ').toString()
  } else {
    return ''
  }
}

export const getLocationLinkFromProps = (props) => {
  const address = getLocationAddress(props)
  const lat = props.lat
  const lng = props.lng

  return `https://www.google.com/maps/search/?api=1&query=${address}&ll=${lat},${lng}&z=15`
}

export const getLocationLinkFromLocation = (location) => {
  const address = getFullAddress(location)
  const lat = location.lat
  const lng = location.lng

  return `https://www.google.com/maps/search/?api=1&query=${address}&ll=${lat},${lng}&z=15`
}

export const getLocation = (locations, type) => {
  return locations.find(location => location.type.id === type)
}

export const getMainLocation = (locations) => {
  if (isNil(locations)) return null
  let ret = locations.find(l => l.type.id === LocationTypes.main)
  if (ret === null && locations.length > 0) ret = locations[0]
  return ret
}

export const getFullAddress = (location) => {
  return getFullAddressWithSep(location, ', ', true)
}

export const getFullAddressWithSep = (location, sep, includeCountry) => {
  const ret = []
  addAddressField(ret, location.address1)
  addAddressField(ret, location.address2)
  addAddressField(ret, location.address3)
  addAddressField(ret, location.city)
  addAddressField(ret, location.county)
  addAddressField(ret, location.postCode)
  if (includeCountry) addAddressField(ret, location.country)
  return ret.join(sep)
}

const addAddressField = (array, field) => {
  if (field && field.length > 0) array.push(field)
}

export const geocodeAddress = (address) => {
  return new Promise(resolve => {
    const geoCoder = new google.maps.Geocoder()
    geoCoder.geocode({'address': address}, (results, status) => {
      resolve(status === google.maps.GeocoderStatus.OK
          ? results[0].geometry.location
          : null)
    })
  })
}

export const isGeoLocationDataSet = (location) => {
  return !isNil(location.lat) && !isNil(location.lng) &&
      (location.lat !== 0 && location.lng !== 0)
}

export const getGeoLocation = (location) => {
  return {
    lat: parseFloat(location.lat),
    lng: parseFloat(location.lng),
  }
}

export const getAddressParts = (address) => {
  const parts = address.split(',')
  return {
    address1: parts.length > 0 ? parts[0].trim() : null,
    address2: parts.length > 1 ? parts[1].trim() : null,
    address3: parts.length > 2 ? parts.map(part => part.trim()).slice(2).join(', ') : null,
  }
}

export default {
  LocationTypes,
  getTypes,
  getCountries,
  getLocationAddressFromProps: getLocationAddress,
  getLocationLinkFromProps,
  getLocationLinkFromLocation,
  getMainLocation,
  getFullAddress,
  getFullAddressWithSep,
}
